import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Target = () => {
    return (
        <div className="otpBank-target">
            <FullWrapper>
                <div className="otpBank-targetWrapper">
                    <div className="otpBank-targetLeft">Цель</div>
                    <div className="otpBank-targetRight">
                        Увеличение небрендового поискового трафика для сайта www.otpbank.ru
                        в&nbsp;разделы &laquo;Кредиты&raquo;, &laquo;Услуги для малого
                        бизнеса&raquo; и&nbsp;&laquo;Вклады&raquo; по&nbsp;сравнению
                        с&nbsp;аналогичным периодом предыдущего года.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
